import React from "react";
import "./styles.css";
import { formatarData } from "lib/tratamentoDatas";
import { resolveTranlationTipoColeta } from "constants/tipoColetas";

import { AdvancedMarker } from "@vis.gl/react-google-maps/dist/index.umd.js";
import { useTranslations } from "adapters/i18n";
import { idsFarois } from "constants/idsFarois";
import { constantsInfoFarol, obterPropertiesCocho } from "../../InfoFarol/InfoCochoCompartilhado";

export const renderCorDoIcone = (cor) => {
  switch (cor) {
    case "red":
      return "#FDDFDD";
    case "green":
      return "#F4F7D4";
    default:
      return "rgba(240, 240, 240, 0.98)";
  }
};

const formatarCoordenada = (coordenada) => coordenada.toFixed(2);

const formatarMedidaAltura = (medida) => {
  const mediaMedidaAltura =
    medida.reduce((prev, curr) => {
      return prev + curr.Altura;
    }, 0) / medida.length;
  return mediaMedidaAltura.toFixed(2);
};

const obterNomeTipoColeta = (idTipoColeta, t) => {
  return resolveTranlationTipoColeta(t, idTipoColeta);
};

const renderTipoColetaHeader = (gpsLigado, CapturadaDentroDoPasto, t) => {
  if (!gpsLigado) {
    return <>{t("statusIndicator:without-localization").toLowerCase()}</>;
  }
  if (CapturadaDentroDoPasto) {
    return <>{t("statusIndicator:inside-pasture-area").toLowerCase()}</>;
  }
  return <>{t("statusIndicator:outside-pasture-area").toLowerCase()}</>;
};

const renderGeolocalizacaoLabel = (gpsLigado, position, t) => {
  if (gpsLigado) {
    return (
      <>
        {t("statusIndicator:latitude")} {formatarCoordenada(position.lat)} |{" "}
        {t("statusIndicator:longitude")} {formatarCoordenada(position.lng)}
      </>
    );
  }
  return <>{t("statusIndicator:msg-uncollected-localization")}</>;
};

const obterCamposColeta = (idFarolSelecionado, informacoesColeta, forragem, pastosComCochoCompartilhado, t) => {
  const {
    DataColeta,
    IdTipoColetaAltura,
    MedidaAltura,
    TipoCocho,
    Formulacao,
    QuantidadeFornecida,
    Escore,
    pasto
  } = informacoesColeta;

  if (idFarolSelecionado === idsFarois.alturaPastoAlturaForragem) {
    return [
      { titulo: t("statusIndicator:forage"), conteudo: forragem?.Nome },
      { titulo: t("common:collect-date"), conteudo: formatarData(DataColeta) },
      { titulo: t("common:type"), conteudo: obterNomeTipoColeta(IdTipoColetaAltura, t) },
      { titulo: t("statusIndicator:collected-height"), conteudo: `${formatarMedidaAltura(MedidaAltura)} cm` }
    ].filter(campo => campo.conteudo);
  }

  if (idFarolSelecionado === idsFarois.cochoProduto) {
    const { farolPasto } = pasto || {};
    const constants = constantsInfoFarol(t);

    const properties = obterPropertiesCocho(
      pastosComCochoCompartilhado,
      farolPasto,
      idFarolSelecionado,
      constants
    );

    const camposDosFarois = Object.keys(properties).map(key => ({
      titulo: key,
      conteudo: Array.isArray(properties[key]) ? properties[key].join(", ") : properties[key]
    }));

    return [

      ...camposDosFarois,
      { titulo: t("statusIndicator:trough-score"), conteudo: Escore },
      { titulo: t("common:type"), conteudo: TipoCocho },
      { titulo: t("statusIndicator:formulation"), conteudo: Formulacao },
      {
        titulo: t("statusIndicator:quantity-supplied"),
        conteudo: QuantidadeFornecida != null ? `${QuantidadeFornecida} kg` : null
      },
    ].filter(campo => campo.conteudo != null && campo.conteudo !== undefined);
  }

  return [];
};

export const TooltipPasto = ({ informacoesColeta, forragem, idFarolSelecionado, pastosComCochoCompartilhado }) => {

  const { t } = useTranslations();

  const {
    pasto,
    position,
    CapturadaDentroDoPasto,
    gpsLigado,
    url,
    color
  } = informacoesColeta;


  if (pasto) {
    return (
      <AdvancedMarker
        position={pasto.CentroPasto[0]}
        anchorLeft="-50%"
        anchorTop="-50%"
        clickable={false}
        style={{ pointerEvents: "none" }}
      >
        <div className="modal-coleta-wrapper">
          <div
            className="modal-coleta"
          >
            <div className="modal-header">
              <div
                className="coleta-icon"
                style={{
                  backgroundColor: `${renderCorDoIcone(color)}`,
                }}
              >
                <img src={url} alt="" />
              </div>

              <div className="modal-title">
                <h3 className="bold">
                  {t("statusIndicator:measure")} -{" "}
                  {renderTipoColetaHeader(gpsLigado, CapturadaDentroDoPasto, t)}
                </h3>
                <p>GPS {gpsLigado ? "online" : "offline"}</p>
              </div>
            </div>

            <div className="divider"></div>

            <div className="modal-body">
              <ul>

                {obterCamposColeta(idFarolSelecionado, informacoesColeta, forragem, pastosComCochoCompartilhado, t).map((campo, index) => (
                  <li key={index}>
                    {campo.titulo}: <span className="bold">{campo.conteudo}</span>
                  </li>
                ))}
                <li>
                  {t("statusIndicator:geolocalization")}:{" "}
                  <span className="bold">
                    {renderGeolocalizacaoLabel(gpsLigado, position, t)}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </AdvancedMarker>

    );
  }
  return null;
};
